import React from 'react';
import { View } from 'src/components/basic';
import { useScreenDetail } from 'src/helpers';
import { Header } from './Header';
import { MAX_WIDTH, MIN_DESKTOP_HEIGHT, MIN_DESKTOP_WIDTH, remCss } from '../utils';
import FooterInfo from 'src/components/FooterInfo';
import { DoctorsTab } from './DoctorsTab';
import { ContactTab } from './ContactTab';
import { TreatmentsTab } from './TreatmentsTab';
import { GalleryTab } from './GalleryTab';

const WebComponents = ({
  clinic,
  activeTab,
  onActiveTab,
  isConv,
  onSendMsg,
  onBook,
  onDoctorItem,
  onManagerItem,
  onLocation,
  onChatSupport,
  currency,
  onBack
}) => {
  const screen = useScreenDetail();
  const medium = MIN_DESKTOP_WIDTH > screen.innerWidth || MIN_DESKTOP_HEIGHT > screen.innerHeight;

  const contentStyle = {
    flex: 1,
    backgroundColor: 'white',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0,  #0000000a)',
    borderRadius: remCss(20),
    marginBottom: remCss(medium ? 30 : 90),
    marginHorizontal: remCss(50),
    padding: remCss(25),
    ...(screen.innerWidth > MAX_WIDTH + remCss(100) && {
      width: MAX_WIDTH - remCss(50),
      marginHorizontal: 'auto'
    })
  };

  return (
    <View style={{ flex: 1 }}>
      <Header clinic={clinic} activeTab={activeTab} onActiveTab={onActiveTab} medium={medium} />

      {activeTab === 'doctors' && (
        <DoctorsTab
          clinic={clinic}
          medium={medium}
          isConv={isConv}
          onSendMsg={onSendMsg}
          onBook={onBook}
          onDoctorItem={onDoctorItem}
          contentStyle={contentStyle}
          onBack={onBack}
        />
      )}
      {activeTab === 'treatments' && (
        <TreatmentsTab
          clinic={clinic}
          medium={medium}
          contentStyle={contentStyle}
          currency={currency}
        />
      )}
      {activeTab === 'contact' && (
        <ContactTab
          clinic={clinic}
          medium={medium}
          isConv={isConv}
          onChatSupport={onChatSupport}
          onManagerItem={onManagerItem}
          contentStyle={contentStyle}
          onLocation={onLocation}
          onBack={onBack}
        />
      )}
      {activeTab === 'gallery' && (
        <GalleryTab clinic={clinic} medium={medium} contentStyle={contentStyle} />
      )}

      <FooterInfo
        isRotate={screen.isSmallScreen}
        containerStyle={{
          width: '100%',
          maxWidth: MAX_WIDTH,
          marginLeft: 'auto',
          marginRight: 'auto',
          paddingHorizontal: remCss(50)
        }}
      />
    </View>
  );
};


WebComponents.displayName = 'WebComponents';

export default WebComponents;
